import { createSelector } from '@reduxjs/toolkit';
import { RootState } from '..';

export const getNotificationMessages = (state: RootState) => state.notifications.messages;

export const getUnreadNotificationsCount = createSelector(
  [getNotificationMessages],
  messages => messages?.filter(m => !m.read).length ?? 0,
);
